import React from 'react';
import {connect} from 'react-redux';
import {withNamespaces} from 'react-i18next';
import Button from '../../../../components/Button';
import {Container} from './styles';

function ActionBar({t, currentStep, setCurrentStep, steps, errors, loading, onNext, onPrev, onSubmit, nextDisabled, prevDisabled, submitDisabled}) {
  const hasErrors = Object.keys(errors).reduce((_, key) => errors[key] !== false, false);

  async function handleNext({target}) {
    target.blur();

    if (!onNext) {
      setCurrentStep(currentStep + 1, 'next');
      return
    }

    if (await onNext()) {
      setCurrentStep(currentStep + 1, 'next');
    }
  }

  function handlePrev({target}) {
    target.blur();

    if (!onPrev) {
      setCurrentStep(currentStep - 1, 'prev');
      return
    }

    if (onPrev()) {
      setCurrentStep(currentStep - 1, 'prev');
    }
  }

  function handleSubmit({target}) {
    target.blur();

    onSubmit();
  }

  return (
    <Container>
      {
        currentStep > 0
          ? (
            <Button onClick={handlePrev} disabled={hasErrors || loading || prevDisabled}>
              {t('form.actions.prev')}
            </Button>
          )
          : null
      }
      
      {
        currentStep === steps.length - 1
          ? (
            <Button onClick={handleSubmit} disabled={hasErrors || loading || submitDisabled || submitDisabled}>
              {t('form.actions.submit')}
            </Button>
          )
          : (
            <Button onClick={handleNext} disabled={hasErrors || loading || nextDisabled}>
              {t('form.actions.next')}
            </Button>
          )
      }
    </Container>
  );
}

const mapStateToProps = state => ({
  steps: state.signup.steps,
  currentStep: state.signup.currentStep,
  errors: state.signup.errors,
  loading: state.signup.loading
});

const mapDispatchToProps = dispatch => ({
  setCurrentStep: (step, dir) => dispatch({type: 'SET_CURRENT_STEP', payload: [step, dir]})
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ActionBar));
